export default "__VITE_ASSET__jo3uacbt__"